import { AxiosError } from "axios";
import {
  Box,
  Form,
  FormField,
  Text,
  TextInput,
  Button,
  DataTable,
  ColumnConfig,
  Spinner,
} from "grommet";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorDialog from "../../../../common/error-dialog/ErrorDialog";
import { useErrorHandler } from "../../../../common/context/ErrorStore";
import permissionsService from "../../Permissions/permissions.service";
import { PermissionType } from "../../Permissions/types/PermissionType";
import rolesService from "../roles.service";
import { RoleType } from "../types/RoleType";

import "./CreateRole.css";
import { observer } from "mobx-react";
import { useStore } from "../../../../../../../Hooks/useStore";
import { toJS } from "mobx";
import { Mixpanel } from "../../../../../../../util/Helper";
import Pagination from "../../../../common/Pagination/sidebarPagination.tsx/Pagination";

function CreateRole() {
  const { rootStore } = useStore();
  const [permissions, setPermissions] = useState([] as PermissionType[]);
  const [selectedPermission, setSelectedPermission] = useState(
    [] as (string | number)[]
  );
  const [validationError, setValidationError] = useState("");

  const navigate = useNavigate();
  const fromRole = useLocation().state as RoleType;

  useEffect(() => {
    permissionsService
      .listAllPermissions()
      .then((permissions: PermissionType[]) => {
        if (permissions.length == 0) {
          rootStore.errorHandlingStore.displayError(
            "Error: unable to load permissions, please reload the page!"
          );
        } else {
          rootStore.adminStore.handlePermissions(permissions);
        }
      })
      .catch((error) => {
        rootStore.errorHandlingStore.displayError(JSON.stringify(error));
      });
  }, []);

  useEffect(() => {
    if (fromRole !== null) {
      rootStore.adminStore.handleSelectedPermission(
        fromRole.permissions.map((permission) => permission.code)
      );
    }
  }, [fromRole]);

  const columns = useMemo(() => {
    return [
      {
        property: "code",
        header: "Permission Code",
        primary: true,
        search: true,
        render: (item) => {
          return <div className="user-cell-container">{item.code}</div>;
        },
      },
      {
        property: "description",
        header: "Description",
        primary: true,
        render: (item) => {
          return <div className="user-cell-container">{item.description}</div>;
        },
      },
    ] as ColumnConfig<PermissionType>[];
  }, []);

  return (
    <Box className="create-role-container">
      {fromRole != null ? (
        <p className="template-role-text">
          {"Template Selected - " + fromRole.code}
        </p>
      ) : (
        <></>
      )}
      <Form
        validate="change"
        onSubmit={({ value }: { value: any }) => {

          let uInfos = localStorage.getItem("userinfo");
          if(uInfos)
            {
          const userinformation = JSON.parse(uInfos);
          Mixpanel.track("web_create_role_submit_click",{name:userinformation.username});
            }
          const { code, displayName } = value;
          if (rootStore.adminStore.getSelectedPermission.length == 0) {
            rootStore.adminStore.handleValidationError("Please select atleast 1 permission!");
          } else {
            //TODO api call
            const new_role: RoleType = {
              code,
              displayName,
              permissions: [],
              isStandard: false,
            };

            rolesService
              .createRole(new_role)
              .then(async (res) => {
                const assignmentRequests = Promise.all(
                  rootStore.adminStore.getSelectedPermission.map((permissionCode) =>
                    rolesService.assignPermission(
                      new_role.code,
                      permissionCode as string
                    )
                  )
                );
                try {
                  await assignmentRequests;
                  alert("Role created!");
                } catch (e) {
                  if (e instanceof AxiosError) {
                    rootStore.errorHandlingStore.displayError(e.message);
                  } else {
                    rootStore.errorHandlingStore.displayError(
                      "Error occured while assigning permissions to the role: " +
                        new_role.code
                    );
                  }
                }
              })
              .catch((error: AxiosError) => {
                rootStore.errorHandlingStore.displayError(error.message);
              });
          }
        }}
        className="create-role-form"
      >
        <FormField
          name="code"
          htmlFor="textinput-id"
          required
          
          validate={[
            {
              regexp: /^[a-zA-Z0-9]+(-+[a-zA-Z0-9]+)*$/,
              message:
                "These characters can be used: a-z A-Z 0-9 - (must start and end with letters or numbers)",
            },
          ]}
        >
          <TextInput id="textinput-id" name="code" placeholder="Role Name" />
        </FormField>
        <FormField name="displayName" htmlFor="textinput-id" required>
          <TextInput
            id="textinput-id"
            name="displayName"
            placeholder="Description"
          />
        </FormField>
        <br />
        <div className="permission-table-container">
          <div className="permission-table-header">
            <p className="permission-table-header-text"> Select Permissions</p>
          </div>

          <DataTable
            id="table-id"
            border={"all"}
            className="user-list-table-container"
            background={{
              header: { color: "brand-1" },
            }}
            columns={columns}
            data={rootStore.adminStore.getPermissions}
            resizeable
            // step={5}
            sortable
            title="Permissions"
            onSelect={(items) => {
              if (items.length > 0) {
                rootStore.adminStore.handleValidationError("");
              }
              rootStore.adminStore.handleSelectedPermission(items);
            }}
            select={rootStore.adminStore.getSelectedPermission}
  
          />
      
      
          {rootStore.adminStore.getPermissions.length == 0 ? (
            <div className="spinner-container">
              <Spinner
                border={[
                  { side: "all", color: "transparent", size: "medium" },
                  { side: "horizontal", color: "brand", size: "medium" },
                ]}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        {rootStore.adminStore.getValidationError !== "" ? (
          <p className="validation-text">{rootStore.adminStore.getValidationError}</p>
        ) : (
          <></>
        )}

        <Box direction="row" gap="medium" pad={"medium"}>
          <Button
            type="button"
            label="Back"
            color={"brand-1"}
            onClick={() => {
              let uInfos = localStorage.getItem("userinfo");
              if(uInfos)
                {
const userinformation = JSON.parse(uInfos);
              Mixpanel.track("web_create_role_back_click",{name:userinformation.username});
                }
              navigate(-1);
            }}
          />
          <Button type="reset" onClick={() => {
            
            let uInfos = localStorage.getItem("userinfo");
              if(uInfos)
                {
const userinformation = JSON.parse(uInfos);      
            Mixpanel.track("web_create_role_reset_click",{name:userinformation.username});
                }rootStore.adminStore.resetSelectedPermission();}} label="Reset" color={"brand-1"} />
          <Button type="submit" primary label="Add" color={"brand-1"} />
        </Box>
      </Form>
    </Box>
  );
}

export default observer(CreateRole);
